import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  ADD_SUPPORTUSERS_INIT_ACTION,
  ADD_SUPPORTUSERS_SUCCESS_ACTION,
  ADD_SUPPORTUSERS_FAIL_ACTION,
  FETCH_SUPPORTUSERSLIST_INIT_ACTION,
  FETCH_SUPPORTUSERSLIST_SUCCESS_ACTION,
  FETCH_SUPPORTUSERSLIST_FAIL_ACTION,
  DELETE_SUPPORTUSERS_INIT_ACTION,
  DELETE_SUPPORTUSERS_SUCCESS_ACTION,
  DELETE_SUPPORTUSERS_FAIL_ACTION,
  UPDATE_SUPPORTUSERS_INIT_ACTION,
  UPDATE_SUPPORTUSERS_SUCCESS_ACTION,
  UPDATE_SUPPORTUSERS_FAIL_ACTION,
  FETCH_SUPPORTUSERS_SEARCH_INIT_ACTION,
  FETCH_SUPPORTUSERS_SEARCH_SUCCESS_ACTION,
  FETCH_SUPPORTUSERS_SEARCH_FAIL_ACTION,
} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();

function* addSupportUsers(value) {
 
  try {

    const SupportUsersValue = {
      fName: value.value.fName,
    lName: value.value.lName,
    dsgntn: value.value.dsgntn,
    email: value.value.email,
    mob: value.value.mob,
    };

    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/supportUsers`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(SupportUsersValue),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_SUPPORTUSERSLIST_INIT_ACTION,
      });
      
      yield toast.success("Support User added successfully", {
        autoClose: 3000,
      });
     
      yield put({
        type: ADD_SUPPORTUSERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_SUPPORTUSERS_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* fetchSupportUsersList(value) {
 
  //console.log("saga selected page ", value.value);
  let pageno = value.value === undefined ? 1 : value.value;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/supportUsers?limit=10&page=` + pageno, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
    
      yield put({
        type: FETCH_SUPPORTUSERSLIST_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_SUPPORTUSERSLIST_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* deleteSupportUsers(items) {
 

  const SupportUsersValue = {
    access_token: items.items.id,
  };
 
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/supportUsers/` + items.items.id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  
    if (!res.ok) {    
      let errJSON = {};
      try {
        errJSON = yield res.json();
        if(errJSON){
          yield toast.error("Delete not allowed", {
            autoClose: 3000,
          });
        }
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      yield put({
        type: FETCH_SUPPORTUSERSLIST_INIT_ACTION,
      });
      yield toast.success("Deleted successfully", {
        autoClose: 3000,
      });
      const resJSON = yield res.json();
     
     
      yield put({
        type: DELETE_SUPPORTUSERS_SUCCESS_ACTION,
      });
    }
  } catch (err) {
   
    if (err.ok === false) {
     
      yield put({
        type: DELETE_SUPPORTUSERS_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* editSupportUsers(value) {
  
  let id=value.value.id
  
  const token = localStorage.getItem("token");

  const SupportUsersValue = {
    fName: value.value.fName,
    lName: value.value.lName,
    dsgntn: value.value.dsgntn,
    email: value.value.email,
    mob: value.value.mob,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/supportUsers/`+ id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(SupportUsersValue)

    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
    
      yield put({
        type: FETCH_SUPPORTUSERSLIST_INIT_ACTION,
       
      });
      yield toast.success('Support User updated successfully', {
        autoClose: 3000
    })
    yield put({
      type: UPDATE_SUPPORTUSERS_SUCCESS_ACTION,
      payload: resJSON,
    });
     
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: UPDATE_SUPPORTUSERS_FAIL_ACTION, error: err });
    } else {
    }
  }

}

function* supportUsersSearch(value) {
  
  let searchVal = value.value.searchSupportUsers

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/supportUsers?limit=10&page=` + value.value.Spage + '&search=' + searchVal,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_SUPPORTUSERS_SEARCH_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_SUPPORTUSERS_SEARCH_FAIL_ACTION, error: err });
    } else {
    }
  }
}


export function* SupportUsersActionWatcher() {
  yield takeEvery(ADD_SUPPORTUSERS_INIT_ACTION, addSupportUsers);
  yield takeEvery(FETCH_SUPPORTUSERSLIST_INIT_ACTION, fetchSupportUsersList);
  yield takeEvery(DELETE_SUPPORTUSERS_INIT_ACTION, deleteSupportUsers);
  yield takeEvery(UPDATE_SUPPORTUSERS_INIT_ACTION, editSupportUsers);
  yield takeEvery(FETCH_SUPPORTUSERS_SEARCH_INIT_ACTION, supportUsersSearch);
}

